<template>
	<div>
		<v-layout row wrap align-center>
			<v-flex xs12>
				<p class="title-form">Datos de reserva</p>
			</v-flex>
			<v-flex xs12>
				<v-layout row wrap align-center justify-center>
					<v-flex xs2>
						<v-subheader class="pl-0">Código de Reserva</v-subheader>
						<v-text-field
							type="text"
							class="input-border-inset"
							v-model="params.code">
						</v-text-field>
					</v-flex>
					<v-flex xs3 px-2>
						<v-subheader class="pl-0">Fecha de ingreso</v-subheader>
						<v-menu
							lazy
							v-model="menuEnter"
							transition="scale-transition"
							offset-y
							full-width
							class="menu-date-picker menu-form"
							max-width="290px">
							<v-text-field
								slot="activator"
								label="Fecha de ingreso"
								v-model="params.dateEnter"
								append-icon="event"
								single-line
								hide-details
								readonly
							></v-text-field>
							<v-date-picker
								v-model="params.dateEnter"
								locale="es-PE"
								:date-format="changeFormatDate"
								:formatted-value="formatted"
								v-on:input="validDate"
								no-title
								scrollable>
							</v-date-picker>
						</v-menu>
					</v-flex>
					<v-flex xs3 pr-2>
						<v-subheader class="pl-0">Fecha de salida</v-subheader>
						<v-menu
							lazy
							v-model="menuOut"
							transition="scale-transition"
							offset-y
							full-width
							class="menu-date-picker menu-form"
							max-width="290px">
							<v-text-field
								slot="activator"
								label="Fecha de salida"
								v-model="params.dateOut"
								append-icon="event"
								single-line
								hide-details
								readonly
							></v-text-field>
							<v-date-picker
								v-model="params.dateOut"
								locale="es-PE"
								:date-format="changeFormatDate"
								:formatted-value="formatted"
								:allowed-dates="allowedDatesOut"
								no-title
								scrollable>
							</v-date-picker>
						</v-menu>
					</v-flex>
					<v-flex xs2>
						<v-subheader class="pl-0">Estado</v-subheader>
						<v-select
							class="filter-select"
							:items="status"
							item-text="name"
							item-value="id"
							v-model="params.state"
							hide-details
							single-line
							bottom>
						</v-select>
					</v-flex>
					<v-flex xs2 pl-2>
						<v-subheader class="pl-0">Nº de Habitación</v-subheader>
						<v-text-field
							type="text"
							class="input-border-inset"
							v-model="params.room">
						</v-text-field>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 mt-4>
				<v-divider class="divider-form"></v-divider>
			</v-flex>
			<v-flex xs12>
				<table-run
					:columns="columns"
					:rows="rows"
					:include-delete="false"
					:include-export-to-excel="false"
					:include-search="false"
					:selectable="false"
					class="no-selectable-table no-search-table">
					<template slot="rows" scope="props">
						<td>{{ props.row.code }}</td>
						<td>{{ props.row.customer.lastname }}, {{ props.row.customer.name }}</td>
						<td>{{ props.row.country.code }}</td>
						<td>{{ props.row.dateEnter }}</td>
						<td>{{ props.row.dateOut }}</td>
						<td>{{ props.row.bookingRoom.type }}</td>
						<td>{{ props.row.bookingRoom.number }}</td>
						<td>{{ props.row.occupiedRoom.type }}</td>
						<td>{{ props.row.mp }}</td>
						<td>{{ props.row.anb }}</td>
						<td>{{ props.row.state }}</td>
						<td>{{ props.row.company }}</td>
					</template>    
				</table-run>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	import { addDays, differenceInDays, format, isAfter } from 'date-fns';
	import TableRun from 'table-run';
	import mixin from '@/shared/mixins';
	import { round } from '@/shared/filters';

	function created() {
		this.loadData();
	}

	function allowedDatesOut(date) {
		const newDay = new Date(this.dateEnter).getDate() + 2;
		const newMonth = new Date(this.dateEnter).getMonth() + 1;
		const newYear = new Date(this.dateEnter).getFullYear();
		const newDate = `${newYear}-${newMonth}-${newDay}`;
		return isAfter(new Date(date), new Date(newDate));
	}

	function changeFormatDate(value) {
		return new Date(value).toISOString().substr(0, 10);
	}

	function changeIcon(result) {
		this.onChange = result;
	}

	async function loadData() {
		await this.$http.get('bookings', { params: this.params });
	}

	function validDate(date) {
		this.dateOut = differenceInDays(new Date(this.dateOut), new Date(date)) < 0 ?
			format(addDays(new Date(date), 2), 'YYYY-MM-DD') : this.dateOut;
	}

	function data() {
		return {
			columns: [
				{ id: 1, name: 'Reserva' },
				{ id: 2, name: 'Huesped' },
				{ id: 3, name: 'País' },
				{ id: 4, name: 'Entrada' },
				{ id: 5, name: 'Salida' },
				{ id: 6, name: 'Tipo Res' },
				{ id: 7, name: 'Nº Hab' },
				{ id: 8, name: 'Tipo Ocu' },
				{ id: 9, name: 'MP' },
				{ id: 10, name: 'ANB' },
				{ id: 11, name: 'Estado' },
				{ id: 12, name: 'Entidad' },
			],
			dateCreation: format(new Date(), 'YYYY-MM-DD'),
			dateEnter: format(new Date(), 'YYYY-MM-DD'),
			dateOut: format(addDays(new Date(), 1), 'YYYY-MM-DD'),
			formatted: '',
			loading: false,
			menuEnter: false,
			menuOut: false,
			onChange: false,
			params: {
				code: '',
				dateEnter: '',
				dateOut: '',
				state: 0,
				room: '',
			},
			rows: [],
			status: [
				{ id: 1, name: 'Reserva' },
			],
		};
	}

	export default {
		name: 'booking-filter',
		components: {
			TableRun,
		},
		created,
		data,
		filters: {
			round,
		},
		methods: {
			allowedDatesOut,
			changeFormatDate,
			changeIcon,
			loadData,
			validDate,
		},
		mixins: mixin,
	};
</script>

<style lang="scss" scoped>
	.form-button {
		background-color: transparent;
		box-shadow: none;

		.btn {
			background-color: map-get($colors, button-form) !important;
			border-radius: 0px;
			box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .18) !important;
			color: white;
			height: 40px;
			margin-right: 14px;
			min-width: 98px;
			opacity: 1;

			&--active {
				background-color: map-get($colors, default-skyblue) !important;
			}
		}
	}

	.divider-form {
		margin: 0 -20px;
		width: 100vw;
	}

	.chip {
		background-color: map-get($colors, default-skyblue);
		border-radius: 0px;
		box-shadow: none !important;
		font-size: 10px;
		height: 18px;
		line-height: 18px;
		justify-content: center;
		padding: 0px;
		text-transform: uppercase;
		width: 65px;
	}

	.disabled-block {
		opacity: .5;
	}

	.btn-save-form {
		max-width: 100% !important;
	}
</style>


// WEBPACK FOOTER //
// Filter.vue?60c6d3c1